// extracted by mini-css-extract-plugin
export default {"wrapper":"CreateProfile_wrapper__bzEsd","select":"CreateProfile_select__ZE-Bl","logout":"CreateProfile_logout__DdP7Y"};